<template>
  <div class="hold-transition">
    <loading v-if="cargando" />
    <div class="wrapper">
      <div class="content-wrapper">
        <section class="content-header">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6">
                <h5 class="mb-0">Autorizaciones</h5>
              </div>
              <div class="col-sm-6">
                <ol class="breadcrumb float-sm-right">
                  <li class="breadcrumb-item">
                    <router-link to="/">Home</router-link>
                  </li>
                  <li class="breadcrumb-item active">Administrativo</li>
                  <li class="breadcrumb-item active">Básico</li>
                  <li class="breadcrumb-item active">General</li>
                  <li class="breadcrumb-item active">Autorizaciones</li>
                </ol>
              </div>
            </div>
          </div>
        </section>
        <section class="content">
          <div class="container-fluid">
            <div class="card">
              <div class="card-header pt-2 pb-2">
                <div class="row">
                  <div class="col-md-4">
                    <label> Buscar en la tabla</label>
                    <input
                      type="text"
                      class="form-control form-control-sm border border-dark shadow"
                      v-model="filtros.filter"
                      @keyup.enter="getIndex()"
                    />
                  </div>
                  <div class="col-md-3 text-center">
                    <div
                      v-if="cargando"
                      class="spinner-border text-dark"
                      role="status"
                    ></div>
                  </div>
                  <div class="col-md-5">
                    <div class="float-right">
                      <!-- Solo visible si tiene permiso admin.autorizaciones.export -->
                      <button
                        type="button"
                        class="btn bg-navy mr-2"
                        title="Descargar información de autorizaciones"
                        @click="prepararExportModal()"
                        v-if="$store.getters.can('admin.autorizaciones.export')"
                      >
                        <i class="far fa-file-excel"></i>
                        Descargar archivo

                      </button>
                      <button
                        type="button"
                        class="btn bg-navy"
                        @click="getIndex()"
                      >
                        <i class="fas fa-sync fa-spin"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <!-- /.card-header -->
              <div class="card-body p-0 table-responsive">
                <table
                  id="autorizaciones"
                  class="
                    table table-bordered table-striped table-hover table-sm
                  "
                  v-if="$store.getters.can('admin.autorizaciones.index')"
                >
                  <thead class="thead-dark">
                    <tr>
                      <!---Inicio Select Filtro Tipo Solicitud --->
                      <th style="min-width: 15em">
                        Tipo Solicitud
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.tipo_solicitud"
                          @change="getIndex()"
                        >
                          <option value="">Seleccione...</option>
                          <template
                            v-for="tipo_solicitud in listasForms.tiposolicitud"
                          >
                            <option
                              v-if="
                                $store.getters.can(
                                  'admin.autorizaciones.tipo_Solicitud_' +
                                    tipo_solicitud.descripcion
                                )
                              "
                              :key="tipo_solicitud.numeracion"
                              :value="tipo_solicitud.numeracion"
                            >
                              {{ tipo_solicitud.descripcion }}
                            </option>
                          </template>
                        </select>
                      </th>
                      <th class="text-center p-3">Cambios</th>
                      <!---Inicio Input Filtro Usuario Solicita --->
                      <th style="min-width: 15em">
                        Usuario Solicita
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="usuario_solicita_id"
                          placeholder="Usuario"
                          label="name"
                          :options="listasForms.usuario"
                          @search="buscarUsuario"
                          @input="getIndex()"
                        >
                        </v-select>
                      </th>
                      <th>
                        Fecha Solicitud
                        <input
                          type="date"
                          class="form-control form-control-sm text-nowrap"
                          v-model="filtros.fecha_solicitud"
                          @change="getIndex()"
                        />
                      </th>
                      <!---Inicio Input Filtro Usuario Autoriza --->
                      <th style="min-width: 15em">
                        Usuario Autoriza
                        <v-select
                          :class="
                            $store.getters.getDarkMode ? 'dark-vselect' : ''
                          "
                          class="form-control form-control-sm p-0"
                          v-model="usuario_autoriza_id"
                          placeholder="Usuario"
                          label="name"
                          :options="listasForms.usuario"
                          @search="buscarUsuario"
                          @input="getIndex()"
                        >
                        </v-select>
                      </th>
                      <th>
                        Fecha Autorizacion
                        <input
                          type="date"
                          class="form-control form-control-sm text-nowrap"
                          v-model="filtros.fecha_autorizacion"
                          @change="getIndex()"
                        />
                      </th>
                      <!---Inicio Input Filtro Estado --->
                      <th style="min-width: 10em">
                        Estado
                        <select
                          class="form-control form-control-sm"
                          v-model="filtros.estado"
                          @change="getIndex()"
                        >
                          <option value="">Seleccione...</option>
                          <option
                            v-for="estado in listasForms.estados"
                            :key="estado.numeracion"
                            :value="estado.numeracion"
                          >
                            {{ estado.descripcion }}
                          </option>
                        </select>
                      </th>
                      <th class="text-center p-3">Acción</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="autorizacion in autorizaciones.data"
                      :key="autorizacion.id"
                    >
                      <td class="text-left">
                        {{ autorizacion.ntipo_autorizacion }}
                      </td>
                      <td>
                        <div class="row">
                          <div class="col-md-12">
                            <table
                              id="autorizaciones"
                              class="table table-sm table-bordered none"
                            >
                              <tbody
                                v-for="campo in autorizacion.datos"
                                :key="campo.id"
                              >
                                <td class="none">
                                  <span class="badge bg-pill text-left">
                                    {{ campo[0] }}
                                  </span>
                                </td>
                                <td class="none">
                                  <span
                                    class="badge alert-default-warning text-left"
                                    v-if="campo[1]"
                                  >
                                    {{ campo[1] }}
                                  </span>
                                  <span
                                    class="badge alert-default-danger text-left"
                                    v-else
                                  >
                                    Sin Dato
                                  </span>
                                </td>
                                <td class="none">
                                  <span
                                    class="badge alert-default-success text-left"
                                    v-if="campo[2]"
                                    >{{ campo[2] }}</span
                                  >
                                  <span
                                    class="badge alert-default-danger text-left"
                                    v-else
                                  >
                                    Sin Dato
                                  </span>
                                </td>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </td>
                      <td class="text-center">
                        <span v-if="autorizacion.user_solicita">{{
                          autorizacion.user_solicita.name
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span>{{
                          fechaSolicitud(autorizacion.created_at)
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span v-if="autorizacion.user_autoriza">{{
                          autorizacion.user_autoriza.name
                        }}</span>
                      </td>
                      <td class="text-center">
                        <span>{{
                          autorizacion.estado != 1 ? fechaSolicitud(autorizacion.updated_at) : '' 
                        }}</span>
                      </td>
                      <td class="text-center">
                        <button
                          v-if="autorizacion.estado == 1"
                          class="badge badge-warning"
                          style="cursor: pointer"
                        >
                          PENDIENTE
                          <i class="fas fa-low-vision"></i>
                        </button>

                        <button
                          v-if="autorizacion.estado == 2"
                          class="badge badge-success"
                          style="cursor: pointer"
                        >
                          AUTORIZADO
                          <i class="fas fa-check-circle"></i>
                        </button>

                        <button
                          v-if="autorizacion.estado == 3"
                          class="badge badge-danger"
                          style="cursor: pointer"
                        >
                          RECHAZADO
                          <i class="fas fa-ban"></i>
                        </button>
                      </td>
                      <td
                        class="text-center"
                        v-if="
                          autorizacion.tipo_autorizacion == 16 &&
                            autorizacion.created_at < fechaCor &&
                            autorizacion.estado == 1
                        "
                      >
                        <div class="btn-group float-right">
                          <button
                            type="button"
                            class="btn btn-info"
                            style="cursor: pointer"
                            @click="alertaModal()"
                          >
                            <i class="fas fa-list-alt"></i>
                          </button>
                        </div>
                      </td>
                      <td v-else>
                        <button
                          type="button"
                          class="btn btn-info"
                          data-toggle="modal"
                          data-target="#modal-form-cam"
                          style="cursor: pointer"
                          @click="getModalData(autorizacion)"
                        >
                          <i class="fas fa-list-alt"></i>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <div class="card-footer">
                <div class="float-left" v-if="autorizaciones.total">
                  Mostrando del <b>{{ autorizaciones.from }}</b> al
                  <b>{{ autorizaciones.to }}</b> de un total:
                  <b>{{ autorizaciones.total }}</b> Registros
                </div>
                <div class="float-left" v-else>
                  <span class="badge badge-danger">
                    No hay registros para mostrar
                  </span>
                </div>
                <pagination
                  :data="autorizaciones"
                  @pagination-change-page="getIndex"
                  :limit="5"
                  class="float-right"
                ></pagination>
              </div>
            </div>
          </div>
        </section>
        <AutorizacionesCambio ref="AutorizacionesCambio" />

        <!-- Modal exportar autorizaciones -->
        <div class="modal fade" id="modal_form_autorizacion_export" style="background-color: #00000082">
          <div class="modal-dialog modal-xl">
            <div class="modal-content">
              <div class="modal-header bg-geogo-top-left pt-2 pb-2">
                <h4 class="modal-title text-white">Generar listado Autorizaciones</h4>
                <button type="button" class="close text-white" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <!-- Filtros -->
                  <div class="col-md-6">
                    <div class="card card-light m-0">
                      <div class="card-header"><h4 class="card-title">Filtros</h4></div>
                      <div class="card-body pb-0">
                        <div class="form-group row">
                          <label
                            class="col-md-5 font-weight-bold anim-transicion"
                            :class="filtros.tipo_solicitud ? 'text-success' : 'text-danger'"
                          >
                            Tipo Solicitud
                            <i v-if="filtros.tipo_solicitud" class="fas fa-check-circle ml-1 anim-pop"></i>
                          </label>
                          <div class="col-md-7">
                            <select
                              class="form-control form-control-sm border anim-campo"
                              :class="filtros.tipo_solicitud ? 'border-success anim-seleccionado' : 'border-danger'"
                              v-model="filtros.tipo_solicitud"
                            >
                              <option value="">Seleccione...</option>
                              <template v-for="tipo_solicitud in listasForms.tiposolicitud">
                                <option
                                  v-if="$store.getters.can('admin.autorizaciones.tipo_Solicitud_' + tipo_solicitud.descripcion)"
                                  :key="tipo_solicitud.numeracion"
                                  :value="tipo_solicitud.numeracion"
                                >{{ tipo_solicitud.descripcion }}</option>
                              </template>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-md-5">Estado</label>
                          <div class="col-md-7">
                            <select class="form-control form-control-sm" v-model="filtros.estado">
                              <option value="">Seleccione...</option>
                              <option v-for="estado in listasForms.estados" :key="estado.numeracion" :value="estado.numeracion">
                                {{ estado.descripcion }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="form-group row">
                          <label class="col-md-5">Usuario Solicita</label>
                          <v-select
                            :class="[$store.getters.getDarkMode ? 'dark-vselect' : '']"
                            class="form-control form-control-sm p-0 col-md-7"
                            v-model="usuario_solicita_id"
                            placeholder="Usuario"
                            label="name"
                            :options="listasForms.usuario"
                            @search="buscarUsuario"
                          />
                        </div>
                        <div class="form-group row">
                          <label class="col-md-5">Usuario Autoriza</label>
                          <v-select
                            :class="[$store.getters.getDarkMode ? 'dark-vselect' : '']"
                            class="form-control form-control-sm p-0 col-md-7"
                            v-model="usuario_autoriza_id"
                            placeholder="Usuario"
                            label="name"
                            :options="listasForms.usuario"
                            @search="buscarUsuario"
                          />
                        </div>
                        <div class="form-group row">
                          <label class="col-md-5">Fecha Solicitud</label>
                          <input type="date" class="form-control form-control-sm col-md-7" v-model="filtros.fecha_solicitud" />
                        </div>
                        <div class="form-group row">
                          <label class="col-md-5">Fecha Autorizacion</label>
                          <input type="date" class="form-control form-control-sm col-md-7" v-model="filtros.fecha_autorizacion" />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-md-6">
                    <div class="card card-light">
                      <div class="card-header"><h4 class="card-title">Campos</h4></div>
                      <div class="card-body">
                        <div class="row">
                          <div
                            class="custom-control custom-checkbox col-md-6"
                            v-for="col in exportColumnas"
                            :key="col.key"
                          >
                            <input type="checkbox" :id="col.key + '_exp'" v-model="exportForm[col.key]" class="custom-control-input" />
                            <label class="custom-control-label" :for="col.key + '_exp'">{{ col.label }}</label>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="modal-footer justify-content-between">
                <button
                  type="button"
                  class="btn btn-sm bg-navy"
                  @click="generarListadoExcel()"
                  v-if="$store.getters.can('admin.autorizaciones.export')"
                >
                  Generar Listado <i class="fas fa-file-download"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import vSelect from "vue-select";
import axios from "axios";
import moment from "moment";
import pagination from "laravel-vue-pagination";
import AutorizacionesCambio from "./AutorizacionesCambio";
import Loading from "../../../../components/Loading";

export default {
  name: "AutorizacionesIndex",
  components: {
    pagination,
    vSelect,
    Loading,
    AutorizacionesCambio,
  },
  data() {
    return {
      autorizaciones: {},
      cargando: false,
      fechaCor: null,
      fechaAct: null,
      punto_gestion_id: null,
      usuario_solicita_id: null,
      usuario_autoriza_id: null,
      muestraModal: false,
      filtros: {
        filter: "",
        viaje_id: null,
        tipo_solicitud: null,
        punto_gestion_id: null,
        valor_anterior_id: null,
        valor_nuevo_id: null,
        usuario_solicita_id: null,
        usuario_autoriza_id: null,
        estado: null,
        fecha_solicitud: null,
        fecha_autorizacion: null,
      },
      tarifas: {},
      listasForms: {
        tiposolicitud: [],
        usuario: [],
        estados: [],
      },
      // Datos del modal de exportación
      exportErrores: { tipo_solicitud: false },
      exportColumnas: [
        { key: "tipo_autorizacion", label: "Tipo Solicitud" },
        { key: "cambios", label: "Cambios" },
        { key: "usuario_solicita", label: "Usuario Solicita" },
        { key: "fecha_solicitud", label: "Fecha Solicitud" },
        { key: "usuario_autoriza", label: "Usuario Autoriza" },
        { key: "fecha_autorizacion", label: "Fecha Autorizacion" },
        { key: "estado", label: "Estado" },
      ],
      exportForm: {
        tipo_autorizacion: true,
        cambios: true,
        usuario_solicita: true,
        fecha_solicitud: true,
        usuario_autoriza: true,
        fecha_autorizacion: true,
        estado: true,
      },
    };
  },
  methods: {
    prepararFiltros() {
      this.filtros.usuario_solicita_id = null;
      if (this.usuario_solicita_id) {
        this.filtros.usuario_solicita_id = this.usuario_solicita_id.id;
      }

      this.filtros.usuario_autoriza_id = null;
      if (this.usuario_autoriza_id) {
        this.filtros.usuario_autoriza_id = this.usuario_autoriza_id.id;
      }
    },

    prepararExportModal() {
      this.prepararFiltros();
      this.exportErrores.tipo_solicitud = false;
      window.$("#modal_form_autorizacion_export").modal("show");
    },

    getIndex(page = 1) {
      this.cargando = true;
      this.prepararFiltros();

      axios
        .get("/api/admin/autorizaciones?page=" + page, {
          params: this.filtros,
        })
        .then((response) => {
          this.getAutorizaciones(response.data);
          this.cargando = false;
        });
    },

    getAutorizaciones(array) {
      array.data.forEach((autorizacion, index_autorizaciuon) => {
        // Se buscan los valores a mostrar en la pantalla
        let oldValues = JSON.parse(autorizacion.datos_mostrar_ant);
        let newValues = JSON.parse(autorizacion.datos_mostrar_nuevos);
        let arrayChanges = new Array();
        let arrayKeys = new Array();

        if (oldValues || newValues) {
          if (oldValues.length == 0) {
            arrayKeys = Object.keys(newValues);
          } else {
            arrayKeys = Object.keys(oldValues);
          }
          let arrayOldValues = Object.entries(oldValues);
          let arrayNewValues = Object.entries(newValues);
          for (let j = 0; j < arrayKeys.length; j++) {
            let nValue = arrayNewValues.length > 0 ? arrayNewValues[j][1] : "";
            let oValue = arrayOldValues.length > 0 ? arrayOldValues[j][1] : "";
            arrayChanges.push([arrayKeys[j], oValue, nValue]);
          }
        }
        array.data[index_autorizaciuon].datos = arrayChanges;
      });
      this.autorizaciones = array;
    },

    //Función buscar los tipos de solicitud de listas items
    getTipo_solicitud() {
      axios.get("/api/lista/41").then((response) => {
        this.listasForms.tiposolicitud = response.data;
      });
    },

    //Función buscar los estados de autorizaciones de listas items
    getEstados() {
      axios.get("/api/lista/49").then((response) => {
        this.listasForms.estados = response.data;
      });
    },

    //Función buscar los usuarios
    buscarUsuario(search, loading) {
      if (search != "") {
        let me = this;
        loading(true);
        var url = "api/admin/usuarios/lista?name=" + search;
        axios
          .get(url)
          .then(function(response) {
            let respuesta = response.data;
            me.listasForms.usuario = respuesta;
            loading(false);
          })
          .catch(function(error) {
            this.$swal({
              icon: "error",
              title: "Ocurrió un error: " + error,
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 3000,
              timerProgressBar: true,
            });
          });
      }
    },

    getModalData(data) {
      this.$refs.AutorizacionesCambio.modalData = {
        data,
      };
      this.$refs.AutorizacionesCambio.getIndex();
    },

    fechaCorte() {
      this.fechaAct = moment().format("YYYY-MM-DD HH:mm:ss");
      this.fechaCor = moment(this.fechaAct)
        .add(-48, "hours")
        .format("YYYY-MM-DD HH:mm:ss");
    },

    fechaSolicitud(fecha) {
      return moment(fecha).format("YYYY-MM-DD HH:mm:ss");  
    },

    alertaModal() {
      this.$swal({
        title: "No es posible autorizar!!",
        text: "Se excedió la fecha limite",
        icon: "error",
        confirmButtonText: "Aceptar!",
      });
    },

    // --- Exportación Excel ---
    validarFiltrosExport() {
      this.exportErrores.tipo_solicitud = !this.filtros.tipo_solicitud;
      return !this.exportErrores.tipo_solicitud;
    },

    generarListadoExcel() {
      if (!Object.values(this.exportForm).some(Boolean)) {
        this.$swal({
          title: "Seleccione al menos una columna",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 3000,
          showClass: { popup: "" },
          hideClass: { popup: "" },
        });
        return;
      }

      this.prepararFiltros();
      if (!this.validarFiltrosExport()) {
        this.$swal({
          title: "Complete los campos obligatorios marcados",
          toast: true,
          position: "top-end",
          showConfirmButton: false,
          timer: 4000,
          showClass: { popup: "" },
          hideClass: { popup: "" },
        });
        return;
      }

      this.cargando = true;
      axios({
        method: "POST",
        url: "/api/admin/autorizaciones/export",
        data: { form: this.exportForm, filtros: this.filtros },
      })
        .then((response) => {
          this.cargando = false;
          if (response.data && response.data.url) {
            location.href = response.data.url;
          }
        })
        .catch((e) => {
          this.cargando = false;
          let msg = "Ocurrió un error al generar el reporte";
          if (e.response && e.response.data && e.response.data.message) {
            msg = e.response.data.message;
          }
          this.$swal({
            title: msg,
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            showClass: { popup: "" },
            hideClass: { popup: "" },
          });
        });
    },
  },
  mounted() {
    this.getIndex();
    this.getEstados();
    this.fechaCorte();
    this.getTipo_solicitud();
  },
};
</script>
<style>
.none {
  border: none !important;
}

/* Transiciones suaves de color */
.anim-transicion {
  transition: color 0.3s ease-in-out;
}

.anim-campo {
  transition: border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* Mini animación al pasar a verde (seleccionado) */
.anim-seleccionado {
  animation: pulsoVerde 0.45s ease-out;
  box-shadow: 0 0 5px rgba(40, 167, 69, 0.4);
}

@keyframes pulsoVerde {
  0% {
    transform: scale(0.98);
    box-shadow: 0 0 0 0 rgba(40, 167, 69, 0.7);
  }
  50% {
    transform: scale(1.02);
    box-shadow: 0 0 10px 4px rgba(40, 167, 69, 0.4);
  }
  100% {
    transform: scale(1);
    box-shadow: 0 0 5px rgba(40, 167, 69, 0.4);
  }
}

/* Animación de entrada suave para el ícono de check */
.anim-pop {
  animation: popIn 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275);
}

@keyframes popIn {
  0% {
    transform: scale(0);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}
</style>
